<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button class="mr-2" variant="success" @click="exportMonthlyNewUserReport()">匯出每月新增人數報表</b-button>
      </template>
    </bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-checkbox
          class="mb-2"
          switch
          size="lg"
          value=1
          unchecked-value=0
          v-model.number="search.plan"
          @change="getReportMonthAdd(1)"
        >
          是否分組
        </b-form-checkbox>

        <b-form-group label-cols="auto" label-cols-lg="auto" label="開始日期">
          <roc-date-picker-year-month
            class="search-date"
            v-model="search.date_S"
            format="yyy-mm" />
        </b-form-group>

        <b-form-group label-cols="auto" label-cols-lg="auto" label="結束日期">
          <roc-date-picker-year-month
            class="search-date"
            v-model="search.date_E"
            format="yyy-mm" />
        </b-form-group>

        <b-button v-if="search.date_S && search.date_E" variant="info" @click="openContractModal(search, true)">搜尋範圍契約資料</b-button>
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getReportMonthAdd(1)">搜尋</b-button>
        </div>
      </div>
    </div>



    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      :pageData="data.page"
      v-on:result="getReportMonthAdd"
    >
      <template #cell(year_month)="row">
        <span v-if="search.plan">
          {{ Number(row.item.month.split('-')[0]) - 1911 }}-{{ row.item.month.split('-')[1] }}
        </span>

        <span
          v-else
          class="link"
          @click="openContractModal(row.item)"
        >
         {{ Number(row.item.month.split('-')[0]) - 1911 }}-{{ row.item.month.split('-')[1] }}
        </span>
      </template>

      <template #cell(bar_chart)="row">
        <b-progress :value="row.item.count" :max="data.bar_max_value" show-value></b-progress>
      </template>

    </tables-page>

    <!-- 契約 modal -->
    <monthly-new-user-contract-modal
      v-model="status.contractModal"
      :data="data.temp_table_data"
      :isDateRange="status.isDateRange" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import MonthlyNewUserContractModal from"./components/modal/MonthlyNewUserContractModal";
import { downloadFile, getFirstAndLastDayOfMonth } from "@/models/HELPERS/common.js";
import RocDatePickerYearMonth from "@/components/common/RocDatePickerYearMonth";

export default {
  name: 'monthlyNewUserReport',
  components: {
    BreadCrumb,
    TablesPage,
    MonthlyNewUserContractModal,
    RocDatePickerYearMonth
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '每月新增人數', url: '', isActive: false }
        ]
      },
      status: {
        contractModal: false,
        isDateRange: false
      },
      search: {
        plan: 0,
        date_S: '',
        date_E: ''
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "year_month",
            label: "年月",
          },
          {
            key: "count",
            label: "人數",
          },
          {
            key: "bar_chart",
            label: "長條圖",
          }
        ],
        page: {},
        temp_table_data: {},
        bar_max_value: 100,
      },
    }
  },
  computed: {
    tableFields() {
      let fields = [
        {
          key: "year_month",
          label: "年月",
        },
        {
          key: "count",
          label: "人數",
        },
        {
          key: "bar_chart",
          label: "長條圖",
        }
      ];

      if (this.search.plan) {
        fields.unshift({
          key: "plan",
          label: "組別",
        })
      }

      return fields;
    }
  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.reportApi.page);
      this.getReportMonthAdd();
    },
    // 取得每月新增人數
    getReportMonthAdd(pageIndex = null) {
      const date_S = this.search.date_S ? getFirstAndLastDayOfMonth(this.search.date_S, false, true).first_day : '';
      const date_E = this.search.date_E ? getFirstAndLastDayOfMonth(this.search.date_E, false, true).last_day : '';
      const params = {
        ...this.search,
        'date_S': date_S,
        'date_E': date_E,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };

      this.reportApi.getReportMonthAdd((response) => {
        const res = response.data;

        this.data.bar_max_value = Math.max(...res.data.map(item => item.count));
        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 開啟契約 modal
    openContractModal(item = null, is_date_range = false) {
      this.status.contractModal = true;
      this.status.isDateRange = is_date_range;
      this.data.temp_table_data = Object.assign({}, item);
    },
    // 匯出每月新增人數報表
    exportMonthlyNewUserReport() {
      const params = {
        ...this.search,
        type: 1
      };

      this.reportApi.exportReportMonth((response) => {
        if (!response) return;

        downloadFile(response);
      }, params)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        plan: 0,
        date_S: '',
        date_E: ''
      }

      this.getReportMonthAdd(1);
    },
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    flex-basis: 80%;
    .search-date {
      width: 50%;
    }
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/monthlyNewUserReport.vue